import ReactDOM from "react-dom";
import loadable from "@loadable/component";
import getWindow from "../utils/window";
import ErrorBoundary from "../components/errorBoundary/ErrorBoundary";
import ProductName from "../components/productName/ProductName";
import StockPriceRetry from "../components/stockPriceRetry/StockPriceRetry";
import MixAndMatchProductInfo from "../components/mixAndMatchProductInfo/MixAndMatchProductInfo";
import Spacing, { SPACING } from "../components/spacing/Spacing";
import Prop65GroupWarning from "../components/prop65/Prop65GroupWarning";
import MixAndMatchProducts from "../components/mixAndMatchProducts/MixAndMatchProducts";
import styles from "./MixAndMatchPage.scss";
import NewInBox from "../components/newInBox/NewInBox";
import ReleaseDateBanner from "../components/releaseDateBanner/ReleaseDateBanner";
import HeroGallery from "../components/heroGallery/HeroGallery";
import ViewportOnly from "../containers/viewportOnly/ViewportOnly";

const App = loadable(
  () => import(/* webpackChunkName: "deferred" */ "../LoadableComponents"),
  {
    ssr: false,
    resolveComponent: ({ App }) => App,
  },
);

const SocialShare = loadable(
  () => import(/* webpackChunkName: "deferred" */ "../LoadableComponents"),
  {
    ssr: false,
    resolveComponent: ({ SocialShare }) => SocialShare,
  },
);

export default function MixAndMatchPage() {
  return (
    <>
      <HeroGallery />
      <div className={styles.aside}>
        <div className={styles.titleContainer}>
          <ProductName />
          <SocialShare />
        </div>
        <Spacing size={SPACING.SIXTEEN}>
          <MixAndMatchProductInfo />
          <NewInBox />
          <Prop65GroupWarning />
          <ViewportOnly medium large>
            <ReleaseDateBanner />
          </ViewportOnly>
        </Spacing>
        <StockPriceRetry />
        <MixAndMatchProducts />
      </div>
      {getWindow()
        ? ReactDOM.createPortal(
            <ErrorBoundary>
              <App />
            </ErrorBoundary>,
            getWindow().document.getElementById("pdp-react-app"),
          )
        : null}
    </>
  );
}
